import React, {Component} from 'react'
import {AppContext} from "@lightspeed-invoicing/core-client/frontend";

class UserNameLabel extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            userId: this.props.value || '',
            name: '',
        }
    }


    componentWillReceiveProps(nextProps) {
        this.loadUser(nextProps.value)
    }

    componentDidMount() {
        this.loadUser(this.state.userId)
    }

    loadUser(userId) {
        if (!userId) {
            return
        }
        if (this.state.userId !== userId || !this.state.name) {
            AppContext.getApiClient().get(`/users/${userId}`).then(res => {
                this.setState({
                    userId: userId,
                    name: res?.attributes?.name || '',
                })
            })
        }
    }


    render() {
        return <span className={this.state.className}>
            {this.state.name}
        </span>
    }
}

export default UserNameLabel





// WEBPACK FOOTER //
// ./src/common/user/label.component.jsx